import Vue from 'vue'
import Router from 'vue-router'
import homeview from "@/components/home.vue"
import itemview from "@/components/item.vue"
import userview from "@/components/user.vue"
import myteam from "@/components/myteam.vue"
import settingsview from "@/components/settings.vue"
import incomeview from "@/components/income.vue"
import copyinviteview from "@/components/copy-invite.vue"
import deliverview from "@/components/delivery-addresses.vue"
import kj from "@/components/kj.vue"
import fccoinsview from "@/components/fc-coins.vue"
import claimfcview from "@/components/claim-fc.vue"
import KlinePage from '@/components/KlinePage.vue'
import cycswap from '@/components/cycswap.vue'
Vue.use(Router)
const routes=[
    {
        path:'/',
        redirect:'/home'
    },
    {
        path:'/home',
        component:homeview
    },
    {
        path:'/user',
        component:userview
    },
    {
        path:'/myteam',
        component:myteam
    },
    {
        path:'/kj',
        component:kj
    },
    {
        path:'/settings',
        component:settingsview
    },
    {
        path: '/fc-coins',
        component: fccoinsview
    },
    {
        path:'/income',
        component:incomeview
    },
    {
        path:'/copy-invite',
        component:copyinviteview
    },
    {
        path:'/item',
        component:itemview
    },
    {
        path: '/claim-fc',
        component: claimfcview
    },
    
    {
        path: '/delivery',
        component: deliverview
    },
    {
        path: '/kline',
        name: 'Kline',
        component: KlinePage
    },
    {
        path: '/cycswap',
        name: 'Cycswap',
        component: cycswap
    }



]
export default new Router({
    routes
})